<rask-page
  pageTitle="{{ 'KUNDORDER_LIST_SOK' | translate }}"
  [actionShow]="canEdit()"
  [actionFn]="create"
  actionTitle="{{'KUNDORDER_LIST_SKAPA_NY' | translate}}"
  noPadding>
  <ng-container headerContent>
    <form [formGroup]="form" (ngSubmit)="searchKundorder()">
      <div class="row">
        <rask-search
          aid="inputKundnamn"
          class="col-2"
          label="{{'KUNDORDER_LIST_KUNDNAMN' | translate}}"
          bindLabel="namn"
          typeToSearchText="{{ 'DEFAULT_TYPE_AHEAD_HELP_TEXT' | translate }}"
          loadingText="Laddar..."
          notFoundText="Ingen träff"
          [minTermLength]="3"
          [typeaheadFn]="kundTypeAhead"
          [selected]="form.value.kund"
          formControlName="kund">
        </rask-search>
        <rask-input
          aid="inputBeskrivning" class="col-2"
          label="{{ 'KUNDORDER_LIST_BESKRIVNING' | translate }}"
          formControlName="beskrivning"
          [rule]="" name="beskrivning">
        </rask-input>
        <rask-datepicker
          aid="inputPeriodFrom" class="col-1"
          formControlName="periodFrom"
          label="{{'KUNDORDER_LIST_PERIODFROM' | translate}}"
          [minDate]="" [onlyMonths]="false"
          name="periodFrom">
        </rask-datepicker>
        <rask-datepicker
          aid="inputperiodTom" class="col-1"
          formControlName="periodTom"
          label="{{'KUNDORDER_LIST_PERIODTOM' | translate}}"
          [minDate]="" [onlyMonths]="false"
          name="periodTom">
        </rask-datepicker>
        <rask-selector
          aid="inputAvtalsansvarig"
          class="col-2 search-fix"
          label="{{'KUNDORDER_LIST_AVTALSANSVARIG' | translate}}"
          [minCharacters]="3"
          [debounceTime]="300"
          [getSelectionFromModel]="set"
          placeholder="{{'DEFAULT_TYPE_AHEAD_HELP_TEXT' | translate}}"
          [search]="avtalAnsvarigSearch"
          [viewFormatter]="avtalAnsvarigViewFormatter"
          [formatter]="avtalTypeAheadValueFormatter"
          formControlName="avtalsansvarig">
        </rask-selector>
        <rask-search
          aid="inputMottagningsplats"
          class="col-2"
          label="{{'KUNDORDER_LIST_MOTTAGNINGSPLATS' | translate}}"
          bindLabel="namn"
          typeToSearchText="{{ 'DEFAULT_TYPE_AHEAD_HELP_TEXT' | translate }}"
          loadingText="Laddar..."
          notFoundText="Ingen träff"
          [minTermLength]="3"
          [typeaheadFn]="mottagninsplatsTypeAhead"
          [selected]="form.value.mottagningsplats"
          formControlName="mottagningsplats">
        </rask-search>
        @if (handelssortiment?.length > 0) {
          <rask-tree-selector
            aid="inputHandelssortiment"
            class="col-2"
            [label]="'KUNDORDER_LIST_HANDELSSORTIMENT' | translate"
            [items]="handelssortiment"
            [required]="false"
            [manualItemSync]="true"
            [syncOnClear]="true"
            formControlName="handelssortiment">
          </rask-tree-selector>
        }
      </div>
      <div class="row">
        <rask-input
          aid="inputOrderNummer"
          class="col-2"
          label="{{ 'KUNDORDER_LIST_ORDERNUMMER' | translate }}"
          name="ordernummer"
          formControlName="ordernummer">
        </rask-input>
        <div class="d-flex col-4">
          <rask-submit-button
            aid="kundorderSok"
            color="secondary">
            {{ 'DEFAULT_BUTTON_LABEL_SOK' | translate }}
          </rask-submit-button>
          <rask-button class="reset" aid="buttonRensa" color="secondary" negative (click)="reset()">{{ 'DEFAULT_BUTTON_LABEL_RENSA' | translate }}</rask-button>
        </div>

      </div>
    </form>
  </ng-container>
  <rask-kundorder-list [kundordrar]="kundordrar"></rask-kundorder-list>
</rask-page>
